'use client';

import { useCustomLogos } from '@/features/marketing/hooks/use-custom-logos';
import { useUtmStorage } from '@/features/marketing/hooks/use-utm-storage';

export function InterviewPreparationClientBridge() {
  useUtmStorage();
  useCustomLogos();
  return null;
}
